<ngx-charts-bar-vertical-stacked [results]="productSalesMultiple" [view]="view" [xAxis]="xAxis" [legend]="legend"
    [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxis]="xAxis" [yAxis]="yAxis"
    [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel">
</ngx-charts-bar-vertical-stacked>